<div class="layerpop_wrap ng-scope" style="display: block;">
	<div class="dimbg"></div>
	<div id="layer1" class="pop_layer">
		<div class="pop_container">
			<div class="pop_conts">
				<p class="ctit ct no_fix">Resend Sales Receipt</p>
				<table class="table cancellation-tb">
					<colgroup>
						<col width="175px">
						<col width="*">
						<col width="175px">
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<th>Contract number</th>
							<td colspan="3">{{cancellation.contractNo}}</td>
						</tr>
						<tr>
							<th>Model Code</th>
							<td colspan="3">{{contract.modelCode}}</td>
						</tr>
						<tr>
							<th>Payment type</th>
							<td colspan="3">SINGLEPAY</td>
						</tr>
					</tbody>
				</table>
				<div class="layer-title">
					<h2 class="text-center">Click OK button below to resend the confirmation to your registered email.</h2>
				</div>
				<div class="btn_area">
					<a class="btn btn_type2 btn_layerclose" (click)="onCancel()">Close</a>
					<a class="btn btn_type1 btn_layerclose" (click)="onConfirm()">OK</a>
				</div>
				<a class="sp btn_pop_close btn_layerclose" (click)="onCancel()">
					<i class="sp btn_popclose">Close</i>
				</a>
			</div>
		</div>
	</div>
</div>